import React, { useState, useEffect, useMemo} from "react";
import { useRecoilState } from "recoil";
import { cartState } from "../../NambaStore/state/cartState";
import combinedServices from "../../../shared/services/user-service";
import Swal from "sweetalert2";
import Detail from "../../../assets/images/detail-img.jpg";
import "./productPage.scss";
import getLocalData from "../../../shared/localStorage/getData";
import QRCode from "qrcode";
import { io } from "socket.io-client";
import userConstants from "../../../shared/constants/user-constants";

const POScart = (props) => {
    const [cart, setCart] = useRecoilState(cartState);
    const [cartitem, setCartitem] = useState(cart);
    const [isLoading, setIsLoading] = useState(false);
    const [showQRModal, setShowQRModal] = useState(false);
    const [qrCodeUrl, setQrCodeUrl] = useState("");
    const [isExistingUser, setIsExistingUser] = useState(true);
    const [existingUserEmail, setExistingUserEmail] = useState("");
    const [newUserData, setNewUserData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
    });

    const [userData, setUserdata] = useState()
    const [paymentMethod, setPaymentMethod] = useState("cash");
    const [paymentTimer, setPaymentTimer] = useState(0);
    const [timerInterval, setTimerInterval] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState("pending");
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [userID, SetuserID] = useState(0);
    const socket = useMemo(() => io.connect(userConstants.baseURL), []);
    
    // PayPal Reader states
    const [showReaderModal, setShowReaderModal] = useState(false);
    const [readerCode, setReaderCode] = useState("");
    const [deviceName, setDeviceName] = useState("");
    const [linkedReaders, setLinkedReaders] = useState([]);
    const [selectedReader, setSelectedReader] = useState(null);
    const accessToken = 'test_access_token_123';

    const POSpayment = (data) => {
      console.log(data);
      setPaymentStatus(data.status);
      if (data.status === "success" || data.status === "failed") {
        setIsLoading(false);
      }
    };

    const triggerPOSpayment = (paymentData) => {
      socket.emit("POSpayment", paymentData);
    };
    const storeId = props.storeId;

    const filterCartByStoreId = () => {
        const posCartItems = JSON.parse(localStorage.getItem('POScartItems') || '[]');
        const filteredItems = posCartItems.filter(item => item.storeId === storeId);
        
        localStorage.setItem('POScartItems', JSON.stringify(filteredItems));
        setCart(filteredItems);
        setCartitem(filteredItems);
    };

    useEffect(() => {
      if (getLocalData("user_info", "isLogin")) {
        var loginUserData = getLocalData("user_info", "all").userData
          .login_user_detail.data.user;
        SetuserID(loginUserData.id);
      }
      const fetchUsers = async () => {
        try {
          const response = await combinedServices.getAllUserNames();
          setUsers(response.data);
        } catch (error) {
          console.error("Error fetching users:", error);
        }
      };
      fetchUsers();

      socket.on("POSpayment", POSpayment);
      return () => {
        socket.off("POSpayment", POSpayment);
      };
    }, [socket]);

    useEffect(() => {
      localStorage.setItem("cartItems", JSON.stringify(cart));
      setCartitem(cart);
    }, [cart]);

    useEffect(() => {
        filterCartByStoreId();
    }, [storeId]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredUsers(users);
        } else {
            const filtered = users.filter(user =>
                `${user.user_firstname} ${user.user_lastname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.user_email.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredUsers(filtered);
        }
    }, [searchTerm, users]);

    useEffect(() => {
        if (paymentStatus === "success") {
            clearInterval(timerInterval);
            setShowQRModal(false);
            setIsLoading(false);
            localStorage.removeItem("cartItems");
            localStorage.removeItem("POScartItems");
            setCart([]);
            setCartitem([]);
            Swal.fire({
                title: "Payment Successful!",
                text: "Your payment has been processed successfully.",
                icon: "success",
                confirmButtonText: "OK"
            });
        } else if (paymentStatus === "failed") {
            clearInterval(timerInterval);
            setShowQRModal(false);
            setIsLoading(false);
            Swal.fire({
                title: "Payment Failed!",
                text: "Your payment could not be processed. Please try again.",
                icon: "error",
                confirmButtonText: "OK"
            });
        }
    }, [paymentStatus, timerInterval]);

    const handleUserSelect = (user) => {
        setUserdata(user)
        setExistingUserEmail(user.user_email);
        setSearchTerm(`${user.user_firstname} ${user.user_lastname}`);
        setShowDropdown(false);
    };


    const handleNewUserChange = (e) => {
        const { name, value } = e.target;
        setNewUserData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePaymentMethodChange = (method) => {
        setPaymentMethod(method);
    };

    // PayPal Reader Functions
    const linkPayPalReader = async () => {
        if (!readerCode || !deviceName) {
            Swal.fire({
                icon: "warning",
                title: "Missing Information",
                text: "Please enter both reader code and device name.",
                position: "center"
            });
            return;
        }

        Swal.fire({
            title: "Linking Reader...",
            text: "Please wait while we connect your PayPal Reader",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const result = await combinedServices.connectReader(readerCode, deviceName);
            console.log('Link Reader Result:', result);
            if (result.status !== 200) {
                console.error('Link Reader Error:', result);
                const errorMessage = result.data.error?.errorMessage || "Failed to link reader";
                
                Swal.fire({
                    icon: "error",
                    title: "Link Failed",
                    html: `Message: ${errorMessage}</div>`,
                    position: "center"
                });
                return;
            }
            
            // Success response
            if (result.id || (result.status === 200 && result.data?.id)) {
                const successData = result.data || result;
                console.log('Reader linked successfully:', successData);
                Swal.fire({
                    icon: "success",
                    title: "Reader Linked Successfully!",
                    text: `Device "${successData.integratorTags?.deviceName || deviceName}" has been connected.`,
                    position: "center"
                });
                setShowReaderModal(false);
                setReaderCode("");
                setDeviceName("");
            }
        } catch (error) {
            console.error('Link Reader Exception:', error);
            Swal.fire({
                icon: "error",
                title: "Connection Error",
                text: `Unable to connect to PayPal Reader service: ${error.message}`,
                position: "center"
            });
        }
    };

    const fetchLinkedReaders = async () => {
        try {
            const result = await combinedServices.getLinkedReaders();
            if (result.status === 200) {
                setLinkedReaders(result.data.data || []);
            }
        } catch (error) {
            console.error('Error fetching linked readers:', error);
        }
    };

    const unlinkReader = async (linkId) => {
        try {
            const result = await combinedServices.unlinkReader(linkId);
            if (result) {
                Swal.fire({
                    icon: "success",
                    title: "Reader Unlinked",
                    text: "PayPal Reader unlinked successfully!",
                    position: "center"
                });
                fetchLinkedReaders(); // Refresh the list
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Unlink Failed",
                text: error.message,
                position: "center"
            });
        }
    };

    const processCardPayment = async () => {
        if (!selectedReader) {
            Swal.fire({
                icon: "warning",
                title: "No Reader Selected",
                text: "Please select a PayPal Reader for card payment.",
                position: "center"
            });
            return;
        }

        const totalAmount = cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);
        
        try {
            // First validate the cart
            const validatedData = await combinedServices.validateCartAdmin(cartitem);
            const allValid = validatedData.data.data.every((item) => item.isValid === true);

            if (!allValid) {
                const invalidItems = validatedData.data.data.filter((item) => item.isValid === false);
                const errorMessages = invalidItems
                    .map((item) => `<li><strong>${item.product_name}:</strong> ${item.message}</li> <br>`)
                    .join("");

                Swal.fire({
                    icon: "warning",
                    title: "Cart Issue",
                    html: `<ul style="list-style-type: none; padding-left: 0;">${errorMessages}</ul>`,
                    showCloseButton: true,
                    focusConfirm: false
                });
                return;
            }

            // Create POS order
            const posOrderData = {
                userType: isExistingUser ? "member" : "nonmember",
                addedBy: userID,
                storeID: storeId,
                userId: isExistingUser ? userData.id : 0,
                firstname: isExistingUser ? userData.user_firstname : newUserData.firstName,
                lastname: isExistingUser ? userData.user_lastname : newUserData.lastName,
                email: isExistingUser ? userData.user_email : newUserData.email,
                phone: isExistingUser ? userData.user_areacodemobile + '-' + userData.user_mobile : newUserData.mobile,
                billingaddress: isExistingUser ? userData.user_addr1 : newUserData.address,
                items: cart.map(item => ({
                    id: item.id,
                    inv_id: item.inv_id,
                    name: item.name,
                    price: item.price,
                    quantity: item.quantity,
                    attributes: item.attributes,
                    image: item.image,
                    product_type: item.product_type
                })),
                paymentType: "card",
                transactionId: null,
                country: isExistingUser ? userData.user_country : newUserData.country,
                state: isExistingUser ? userData.user_state : newUserData.state,
                city: isExistingUser ? userData.user_city : newUserData.city,
                zip: isExistingUser ? userData.user_zip : newUserData.zipcode
            };

            const createOrder = await combinedServices.createPOSOrderinTable(posOrderData);
            const order_id = createOrder.data.data[0].order_id;

            // Connect to Zettle reader
            Swal.fire({
                title: "Connecting to Reader",
                text: "Establishing connection with PayPal Reader...",
                icon: "info",
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // Connect to WebSocket
            const connectResult = await combinedServices.connectToZettleReader(selectedReader.id, "channel1");
            
            if (connectResult.status !== 200) {
                throw new Error("Failed to connect to reader");
            }

            // Send payment request
            Swal.update({
                title: "Processing Payment",
                text: "Please insert or tap your card on the PayPal Reader",
                icon: "info"
            });

            const paymentResult = await combinedServices.sendZettlePaymentRequest(
                selectedReader.id,
                order_id,
                parseFloat(totalAmount),
                userID,
                storeId
            );

            if (paymentResult.status !== 200) {
                throw new Error("Failed to send payment request");
            }

            // Listen for payment completion via socket events
            socket.on("payment_completed", (data) => {
                if (data.linkId === selectedReader.id) {
                    Swal.fire({
                        icon: "success",
                        title: "Payment Successful",
                        text: `Card payment of $${totalAmount} processed successfully!`,
                        position: "center"
                    }).then(() => {
                        // Clear cart after successful payment
                        localStorage.removeItem("cartItems");
                        localStorage.removeItem("POScartItems");
                        setCart([]);
                        setCartitem([]);
                    });
                    socket.off("payment_completed");
                    socket.off("payment_failed");
                }
            });

            socket.on("payment_failed", (data) => {
                if (data.linkId === selectedReader.id) {
                    Swal.fire({
                        icon: "error",
                        title: "Payment Failed",
                        text: "Card payment could not be processed. Please try again.",
                        position: "center"
                    });
                    socket.off("payment_completed");
                    socket.off("payment_failed");
                }
            });

            // Set timeout for payment (2 minutes)
            setTimeout(() => {
                socket.off("payment_completed");
                socket.off("payment_failed");
                Swal.fire({
                    icon: "warning",
                    title: "Payment Timeout",
                    text: "Payment session expired. Please try again.",
                    position: "center"
                });
            }, 120000); // 2 minutes

        } catch (error) {
            console.error("Error processing card payment:", error);
            Swal.fire({
                icon: "error",
                title: "Payment Error",
                text: error.message || "An error occurred while processing the payment.",
                position: "center"
            });
        }
    };




    const removeFromCart = (productId, itemId) => {
        const updatedCart = cart.filter(
            (item) => !(item.id === productId && item.inv_id === itemId)
        );
        setCart(updatedCart);
        setCartitem(updatedCart);
    };
    const checkAllInventory = async () => {
        try {
            const updatedCart = await Promise.all(
                cart.map(async (item) => {
                    // Skip non-inventory items
                    if (item.product_type === "non_inventory") {
                        return item;
                    }

                    // Check inventory status for this item
                    const response = await combinedServices.QuantityCheck({
                        inv_id: item.inv_id,
                        quantity: item.quantity // Check if we can add one more
                    });

                    return {
                        ...item,
                        isLastQuantity: response.data.data?.isLastQuantity || false
                    };
                })
            );

            setCart(updatedCart);
            setCartitem(updatedCart);
            localStorage.setItem("cartItems", JSON.stringify(updatedCart));
        } catch (error) {
            console.error("Error checking inventory:", error);
        }
    };

    const updateQuantity = async (itemId, action, isNonInventory = false) => {
        if (isNonInventory) {
            const updatedCart = cart.map((item) => {
                if (item.inv_id === itemId) {
                    let updatedQuantity = item.quantity;

                    if (action === "increment") {
                        updatedQuantity += 1;
                    } else if (action === "decrement" && updatedQuantity > 1) {
                        updatedQuantity -= 1;
                    }

                    return { ...item, quantity: updatedQuantity };
                }
                return item;
            });

            setCart(updatedCart);
            setCartitem(updatedCart);
            localStorage.setItem("cartItems", JSON.stringify(updatedCart));
            return;
        }

        const updatedCart = cart.map((item) => {
            if (item.inv_id === itemId) {
                let updatedQuantity = item.quantity;

                if (action === "increment") {
                    updatedQuantity += 1;
                } else if (action === "decrement" && updatedQuantity > 1) {
                    updatedQuantity -= 1;
                }

                return { ...item, quantity: updatedQuantity };
            }
            return item;
        });

        const updatedItem = updatedCart.find((item) => item.inv_id === itemId);

        try {
            const quantityCheckResponse = await combinedServices.QuantityCheck({
                inv_id: updatedItem.inv_id,
                quantity: updatedItem.quantity
            });
            const isLastQuantity =
                quantityCheckResponse.data.data?.isLastQuantity || false;

            if (quantityCheckResponse.data.status === 200) {
                const finalUpdatedCart = updatedCart.map((item) =>
                    item.inv_id === itemId ? { ...item, isLastQuantity } : item
                );

                setCart(finalUpdatedCart);
                setCartitem(finalUpdatedCart);
                localStorage.setItem("cartitems", JSON.stringify(finalUpdatedCart));
            } else {
                console.error("Not enough quantity available");
                const finalUpdatedCart = updatedCart.map((item) =>
                    item.inv_id === itemId ? { ...item, isLastQuantity: true } : item
                );

                setCart(finalUpdatedCart);
            }
        } catch (error) {
            console.error("Error checking quantity:", error);
        }
    };

    const validateCart = async () => {
        try {
            setIsLoading(true);

            const validatedData = await combinedServices.validateCartAdmin(cartitem);
            const allValid = validatedData.data.data.every(
                (item) => item.isValid === true
            );

            if (allValid) {
                const totalAmount = (
                    cart.reduce((total, item) => total + item.price * item.quantity, 0)
                ).toFixed(2);
                
                const posOrderData = {
                    userType: isExistingUser ? "member" : "nonmember",
                    addedBy: userID,
                    storeID: storeId,
                    userId: isExistingUser ? userData.id : 0,
                    firstname: isExistingUser ? userData.user_firstname : newUserData.firstName,
                    lastname: isExistingUser ? userData.user_lastname : newUserData.lastName,
                    email: isExistingUser ? userData.user_email : newUserData.email,
                    phone: isExistingUser ? userData.user_areacodemobile + '-' + userData.user_mobile : newUserData.mobile,
                    billingaddress: isExistingUser ? userData.user_addr1 : newUserData.address,
                    items: cart.map(item => ({
                        id: item.id,
                        inv_id: item.inv_id,
                        name: item.name,
                        price: item.price,
                        quantity: item.quantity,
                        attributes: item.attributes,
                        image: item.image,
                        product_type: item.product_type
                    })),
                    paymentType: paymentMethod,
                    transactionId: null,
                    country: isExistingUser ? userData.user_country : newUserData.country,
                    state: isExistingUser ? userData.user_state : newUserData.state,
                    city: isExistingUser ? userData.user_city : newUserData.city,
                    zip: isExistingUser ? userData.user_zip : newUserData.zipcode
                };

                try {
                    const createOrder = await combinedServices.createPOSOrderinTable(
                        posOrderData
                    );

                    if (paymentMethod === "cash") {
                        // Clear cart from localStorage and state
                        localStorage.removeItem("cartItems");
                        localStorage.removeItem("POScartItems");
                        setCart([]);
                        setCartitem([]);
                        
                        Swal.fire({
                            icon: "success",
                            title: "Order Placed",
                            text: createOrder.data.message
                        });
                        return
                    }

                    if (paymentMethod === "paypal") {
                        const order_id = createOrder.data.data[0].order_id;
                        const orderData = {
                            items: cartitem,
                            total: totalAmount,
                            orderId: order_id
                        };

                        const apiResponse =
                            await combinedServices.shoppingCartPOSPaypalpayment(orderData);

                        if (apiResponse.data.status === 200) {
                            console.log("Order created successfully:", apiResponse.data);
                            const approvalUrl = apiResponse.data.data.approvalUrl;
                            if (approvalUrl) {
                                // Emit socket event for PayPal payment
                                const paymentData = {
                                    orderId: order_id,
                                    amount: totalAmount,
                                    method: "paypal",
                                    userId: userID,
                                    storeId: storeId,
                                    approvalUrl: approvalUrl,
                                    status: "pending"
                                };
                                triggerPOSpayment(paymentData);
                                
                                const qrCode = await QRCode.toDataURL(approvalUrl);
                                setQrCodeUrl(qrCode);
                                setShowQRModal(true);
                                
                                // Start 5-minute timer
                                setPaymentTimer(300); // 5 minutes = 300 seconds
                                const interval = setInterval(() => {
                                    setPaymentTimer(prev => {
                                        if (prev <= 1) {
                                            clearInterval(interval);
                                            setIsLoading(false);
                                            setShowQRModal(false);
                                            Swal.fire({
                                                icon: "warning",
                                                title: "Payment Timeout",
                                                text: "Payment session expired. Please try again."
                                            });
                                            return 0;
                                        }
                                        return prev - 1;
                                    });
                                }, 1000);
                                setTimerInterval(interval);
                            }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Order Failed",
                                text: "There was an error creating your order."
                            });
                        }
                    }

                } catch (error) {
                    console.error("Error creating order:", error);
                    Swal.fire({
                        icon: "error",
                        title: "Order Failed",
                        text: "An unexpected error occurred while processing your order."
                    });
                }
            } else {
                const invalidItems = validatedData.data.data.filter(
                    (item) => item.isValid === false
                );
                const errorMessages = invalidItems
                    .map(
                        (item) =>
                            `<li><strong>${item.product_name}:</strong> ${item.message}</li> <br>`
                    )
                    .join("");

                Swal.fire({
                    icon: "warning",
                    title: "Cart Issue",
                    html: `<ul style="list-style-type: none; padding-left: 0;">${errorMessages}</ul>`,
                    showCloseButton: true,
                    focusConfirm: false
                });
            }
        } catch (error) {
            console.error("Error validating cart:", error);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "There was an error validating the cart."
            });
        } finally {
            if (paymentMethod !== "paypal") {
                setIsLoading(false); // Stop loader only for non-PayPal payments
            }
        }
    };

    return (
        <>
            <div className="col-lg-4 fixed-cart-container" style={{ marginLeft: '55px' }}>
                <div className="mainCont">
                    <section className="ContactOuter pt-5 pb-5">
                        <div className="container">
                            <div>
                                <div className="mb-3 productHd">
                                    <span>YOUR CART</span>
                                </div>
                                {isLoading && (
                                    <div className="loadingOverlay">
                                        <div className="loadingSpinner"></div>
                                        {showQRModal && (
                                            <div style={{marginTop: '20px', color: 'white', textAlign: 'center'}}>
                                                <p>Waiting for payment...</p>
                                                <p>Time remaining: {Math.floor(paymentTimer / 60)}:{(paymentTimer % 60).toString().padStart(2, '0')}</p>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {cart.length > 0 ? (
                                    <div className="d-flex flex-wrap">
                                        <div className="col-12 col-lg-12 cartInfo">
                                            {cart.map((item) => (
                                                <div
                                                    key={item.id}
                                                    className="inner p-3 p-sm-4 d-flex flex-wrap"
                                                >
                                                    <div
                                                        className="img" style={{ width: "118px" }}
                                                    // onClick={() => handleProductClick(item.id)}
                                                    >
                                                        <img
                                                            src={
                                                                item.image ? JSON.parse(item.image)[0] : Detail
                                                            }
                                                            alt={item.name}
                                                        />
                                                    </div>
                                                    <div className="det ps-s ps-sm-4 pt-3 pt-sm-0">
                                                        <div className="name mb-3">{item.name}</div>
                                                        <div className="price mb-4">
                                                            ${item.price} USD{" "}
                                                            {/* <span className="oldPrice d-block mt-1">
                                  ${item.price.toFixed(2)} USD
                                </span> */}
                                                        </div>
                                                        {/* Display attributes in a single line */}
                                                        <div className="attributes mb-4">
                                                            <div className="attributesList">
                                                                {Object.keys(item.attributes).map(
                                                                    (key, index) => (
                                                                        <span key={index} className="attributeItem">
                                                                            <strong>{key}:</strong>{" "}
                                                                            {item.attributes[key]}
                                                                            {index <
                                                                                Object.keys(item.attributes).length -
                                                                                1 && ", "}
                                                                        </span>
                                                                    )
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="cartActions d-flex align-items-center mb-4">
                                                            {/* Quantity Control */}
                                                            <div className="quantityControl d-flex align-items-center">
                                                                <button
                                                                    className="quantityBtn"
                                                                    onClick={() =>
                                                                        updateQuantity(
                                                                            item.inv_id,
                                                                            "decrement",
                                                                            item.product_type === "non_inventory"
                                                                        )
                                                                    }
                                                                    disabled={item.quantity === 1} // Disable if quantity is 1 for both types
                                                                >
                                                                    -
                                                                </button>
                                                                <span className="quantityDisplay mx-2">
                                                                    {item.quantity}
                                                                </span>
                                                                <button
                                                                    className="quantityBtn"
                                                                    onClick={() =>
                                                                        updateQuantity(
                                                                            item.inv_id,
                                                                            "increment",
                                                                            item.product_type === "non_inventory"
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        item.product_type === "non_inventory"
                                                                            ? false
                                                                            : item.isLastQuantity
                                                                    }
                                                                >
                                                                    +
                                                                </button>
                                                            </div>

                                                            {/* Remove Item */}
                                                            <a

                                                                className="removeLink"
                                                                onClick={() =>
                                                                    removeFromCart(item.id, item.inv_id)
                                                                }
                                                            >
                                                                Remove
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="col-12 col-lg-12 user-info-section mb-4">
                                            <div className="user-type-toggle mb-3">
                                                <button
                                                    className={`toggle-btn ${isExistingUser ? 'active' : ''}`}
                                                    onClick={() => setIsExistingUser(true)}
                                                >
                                                    Member
                                                </button>
                                                <button
                                                    className={`toggle-btn ${!isExistingUser ? 'active' : ''}`}
                                                    onClick={() => setIsExistingUser(false)}
                                                >
                                                    Non-Member
                                                </button>
                                            </div>

                                            {isExistingUser ? (
                                                <div className="existing-user-form">
                                                    <div className="form-group mb-3 position-relative">
                                                        <label htmlFor="memberSearch">Member Search</label>
                                                        <div className="dropdown">
                                                            <input
                                                                type="text"
                                                                id="memberSearch"
                                                                className="form-control"
                                                                placeholder="Search by name or email"
                                                                value={searchTerm}
                                                                onChange={(e) => {
                                                                    setSearchTerm(e.target.value);
                                                                    setShowDropdown(true);
                                                                }}
                                                                onFocus={() => setShowDropdown(true)}
                                                                required
                                                            />
                                                            {showDropdown && (
                                                                <div
                                                                    className="dropdown-menu show w-100 custom-dropdown"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '100%',
                                                                        left: 0,
                                                                        marginTop: '2px'
                                                                    }}
                                                                >
                                                                    <div className="dropdown-content-container">
                                                                        {filteredUsers.length > 0 ? (
                                                                            filteredUsers.map(user => (
                                                                                <button
                                                                                    key={user.id}
                                                                                    type="button"
                                                                                    className="dropdown-item user-option"
                                                                                    onClick={() => handleUserSelect(user)}
                                                                                >
                                                                                    <span className="user-name">
                                                                                        {user.user_firstname} {user.user_lastname}
                                                                                    </span> &nbsp;
                                                                                    <span className="user-email text-muted">
                                                                                        ({user.user_email})
                                                                                    </span>
                                                                                </button>
                                                                            ))
                                                                        ) : (
                                                                            <div className="dropdown-item no-results">No members found</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <input
                                                            type="hidden"
                                                            name="userEmail"
                                                            value={existingUserEmail}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="new-user-form">
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="firstName">First Name</label>
                                                            <input
                                                                type="text"
                                                                id="firstName"
                                                                name="firstName"
                                                                className="form-control"
                                                                placeholder="First Name"
                                                                value={newUserData.firstName}
                                                                onChange={handleNewUserChange}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="lastName">Last Name</label>
                                                            <input
                                                                type="text"
                                                                id="lastName"
                                                                name="lastName"
                                                                className="form-control"
                                                                placeholder="Last Name"
                                                                value={newUserData.lastName}
                                                                onChange={handleNewUserChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="email">Email Address</label>
                                                        <input
                                                            type="email"
                                                            id="email"
                                                            name="email"
                                                            className="form-control"
                                                            placeholder="Email Address"
                                                            value={newUserData.email}
                                                            onChange={handleNewUserChange}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="email">Mobile Number</label>
                                                        <input
                                                            type="number"
                                                            id="mobile"
                                                            name="mobile"
                                                            className="form-control"
                                                            placeholder="Enter Mobile Number"
                                                            value={newUserData.mobile}
                                                            onChange={handleNewUserChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div className="mb-4">
                                            <div className="mb-4">
                                                <label className="d-flex align-items-center mt-2">
                                                    {/* Cash Radio Button */}
                                                    <span className="radioWrapper">
                                                        <input
                                                            type="radio"
                                                            name="paymentMethod"
                                                            value="cash"
                                                            className="radioInpt"
                                                            checked={paymentMethod === "cash"}
                                                            onChange={() => handlePaymentMethodChange("cash")}
                                                        />
                                                        <i className="bg"></i>
                                                    </span>
                                                    <span className="ms-3">Cash</span>
                                                </label>

                                                {/* <label className="d-flex align-items-center mt-2">
                                                    <span className="radioWrapper">
                                                        <input
                                                            type="radio"
                                                            name="paymentMethod"
                                                            value="paypal"
                                                            className="radioInpt"
                                                            checked={paymentMethod === "paypal"}
                                                            onChange={() => handlePaymentMethodChange("paypal")}
                                                        />
                                                        <i className="bg"></i>
                                                    </span>
                                                    <span className="ms-3">PayPal</span>
                                                </label> */}

                                                <label className="d-flex align-items-center mt-2">
                                                    {/* Card Reader Radio Button */}
                                                    <span className="radioWrapper">
                                                        <input
                                                            type="radio"
                                                            name="paymentMethod"
                                                            value="card"
                                                            className="radioInpt"
                                                            checked={paymentMethod === "card"}
                                                            onChange={() => handlePaymentMethodChange("card")}
                                                        />
                                                        <i className="bg"></i>
                                                    </span>
                                                    <span className="ms-3">Card (PayPal Reader)</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-12 cartInfo">
                                            <ul className="payDetail p-0 m-0">
                                                <li className="d-flex justify-content-between pb-2">
                                                    <span>Item's total</span>
                                                    <span>
                                                        $
                                                        {cart
                                                            .reduce(
                                                                (total, item) =>
                                                                    total + item.price * item.quantity,
                                                                0
                                                            )
                                                            .toFixed(2)}
                                                    </span>
                                                </li>

                                                <li className="d-flex justify-content-between pb-2 pt-3 bor">
                                                    <span>Subtotal</span>
                                                    <span>
                                                        $
                                                        {(
                                                            cart.reduce(
                                                                (total, item) =>
                                                                    total + item.price * item.quantity,
                                                                0
                                                            )
                                                        ).toFixed(2)}
                                                    </span>
                                                </li>
                                                <li className="d-flex justify-content-between pb-2 pt-3 bor">
                                                    <span>
                                                        Total (
                                                        {cart.reduce(
                                                            (total, item) => total + item.quantity,
                                                            0
                                                        )}{" "}
                                                        items)
                                                    </span>
                                                    <span>
                                                        $
                                                        {(
                                                            cart.reduce(
                                                                (total, item) =>
                                                                    total + item.price * item.quantity,
                                                                0
                                                            )
                                                        ).toFixed(2)}
                                                    </span>
                                                </li>
                                            </ul>
                                            <div className="mt-4">
                                                {paymentMethod === "card" ? (
                                                    <>
                                                        <button 
                                                            onClick={() => setShowReaderModal(true)} 
                                                            className="btn btn-secondary mb-2 w-100"
                                                        >
                                                            Manage PayPal Readers
                                                        </button>
                                                        <a onClick={processCardPayment} className="checkoutBtn">
                                                            Process Card Payment
                                                        </a>
                                                    </>
                                                ) : (
                                                    <a onClick={validateCart} className="checkoutBtn">
                                                        Proceed to Checkout
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="emptyCart">
                                        <h2>Your Cart is Empty</h2>
                                        <p>
                                            Looks like you haven't added anything to your cart yet.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {/* QR Code Modal */}
            {showQRModal && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Scan QR Code to Pay</h5>
                            </div>
                            <div className="modal-body text-center">
                                <p>Scan this QR code with your mobile device to complete the payment</p>
                                <img src={qrCodeUrl} alt="Payment QR Code" className="img-fluid" />
                                <div className="mt-3">
                                    <p className="text-danger fw-bold">
                                        Time remaining: {Math.floor(paymentTimer / 60)}:{(paymentTimer % 60).toString().padStart(2, '0')}
                                    </p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-danger" 
                                    onClick={() => {
                                        clearInterval(timerInterval);
                                        setShowQRModal(false);
                                        setIsLoading(false);
                                        setPaymentTimer(0);
                                    }}
                                >
                                    Cancel Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* PayPal Reader Management Modal */}
            {showReaderModal && (
                <div className="modal show d-flex align-items-center justify-content-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 1050 }}>
                    <div className="modal-dialog" style={{ maxWidth: '600px', margin: 0 }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fas fa-credit-card me-2"></i>
                                    PayPal Reader Management
                                </h5>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={() => setShowReaderModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                {/* Link New Reader */}
                                <div className="mb-4">
                                    <h6 className="text-primary mb-3">
                                        <i className="fas fa-plus-circle me-2"></i>
                                        Link New Reader
                                    </h6>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Reader Code</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="8-digit code"
                                                value={readerCode}
                                                onChange={(e) => setReaderCode(e.target.value)}
                                                maxLength="8"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Device Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Reader name"
                                                value={deviceName}
                                                onChange={(e) => setDeviceName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <button 
                                        className="btn btn-primary" 
                                        onClick={linkPayPalReader}
                                        disabled={!readerCode || !deviceName}
                                    >
                                        <i className="fas fa-link me-2"></i>
                                        Link Reader
                                    </button>
                                </div>

                                <hr />

                                {/* Linked Readers */}
                                <div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6 className="text-primary mb-0">
                                            <i className="fas fa-list me-2"></i>
                                            Connected Readers ({linkedReaders.length})
                                        </h6>
                                        <button 
                                            className="btn btn-outline-primary btn-sm" 
                                            onClick={fetchLinkedReaders}
                                        >
                                            <i className="fas fa-sync-alt me-1"></i>
                                            Refresh
                                        </button>
                                    </div>
                                    
                                    {linkedReaders.length > 0 ? (
                                        <div className="list-group">
                                            {linkedReaders.map((reader) => (
                                                <div key={reader.id} className={`list-group-item d-flex justify-content-between align-items-center ${
                                                    selectedReader?.id === reader.id ? 'list-group-item-success' : ''
                                                }`}>
                                                    <div>
                                                        <strong>{reader.integratorTags?.deviceName || 'Unnamed Device'}</strong>
                                                        {selectedReader?.id === reader.id && (
                                                            <span className="badge bg-success ms-2">Selected</span>
                                                        )}
                                                        <br />
                                                        <small className="text-muted">ID: {reader.id.substring(0, 8)}...</small>
                                                    </div>
                                                    <div>
                                                        <button
                                                            className={`btn btn-sm me-2 ${
                                                                selectedReader?.id === reader.id ? 'btn-success' : 'btn-outline-success'
                                                            }`}
                                                            onClick={() => setSelectedReader(reader)}
                                                        >
                                                            {selectedReader?.id === reader.id ? 'Selected' : 'Select'}
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => unlinkReader(reader.id)}
                                                        >
                                                            <i className="fas fa-unlink"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-4">
                                            <i className="fas fa-credit-card text-muted mb-3" style={{fontSize: '3rem'}}></i>
                                            <p className="text-muted">No readers connected yet</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary" 
                                    onClick={() => setShowReaderModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </>
    );
};

export default POScart;
